import Unbookmark from '@assets/icons/unbookmark.svg'
import { Icon } from './Icon'

export const UnbookmarkIcon = Icon(Unbookmark)
